import {
  ControlledFormControlWrapper as CoreControlledFormControlWrapper,
  type ControlledFormControlWrapperProps,
} from "@apac/core-form-ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { RequiredBadge } from "@hsbc/portal";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const ControlledFormControlWrapper = ({
  className,
  label,
  required,
  ...rest
}: ControlledFormControlWrapperProps): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "FormControlWrapper");
  const { t } = useI18nContext();

  if (Boolean(label) && required === true) {
    return (
      <CoreControlledFormControlWrapper
        className={clsx(block, className)}
        {...rest}
        label={
          <span className={cn("label-row")}>
            <span className={cn("label")}>{label}</span>
            <RequiredBadge label={t("apac.form.requiredLabel")} />
          </span>
        }
        required={required}
      />
    );
  }

  return (
    <CoreControlledFormControlWrapper
      className={className}
      label={label}
      required={required}
      {...rest}
    />
  );
};
